// extracted by mini-css-extract-plugin
module.exports = {"contentBoxTitle":"styles_contentBoxTitle__2usaY","contentBoxBody":"styles_contentBoxBody__39eZM","contentBoxFooter":"styles_contentBoxFooter__1GzWH"};